import { cn } from "../../lib/utils";

const sizeClasses: Record<string, string> = {
  sm: "h-4 w-4 border-2",
  md: "h-6 w-6 border-2",
  lg: "h-8 w-8 border-[3px]",
};

export interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: "sm" | "md" | "lg";
}

/**
 * Shadcn-style circular loading spinner.
 * Use for inline "loading" states (buttons, cards, sections).
 */
function Spinner({ className, size = "md", ...props }: SpinnerProps) {
  return (
    <div
      role="status"
      aria-label="Loading"
      className={cn(
        "rounded-full border-border border-t-primary animate-spin",
        sizeClasses[size],
        className
      )}
      {...props}
    />
  );
}

export { Spinner };
